import React from 'react'
import { func, string } from 'prop-types'
import intl from 'react-intl-universal'
import { NavItem, NavLink, Image, DropdownMenu, DropdownItem, SVGIcon } from 'components/qstrap'

const DesktopMenuDropdown = ({ name, dropdownOnClick }) => (
  <NavItem className="hidden-md-down dropdown">
    <NavLink dropdownToggle dataToggle="dropdown" aria-expanded="false" onClick={dropdownOnClick}>
      <Image src="/assets/img/avatar.png" className="avatar avatar-sm m-r-sm" />
      <span className="user-display-name hidden-md-down">{name}</span>
    </NavLink>
    <DropdownMenu className="campus-nav-dropdown">
      <DropdownItem href="/profile" className="p-y-md">
        <Image className="icon-nav icon-align-middle m-r-md" src="/assets/img/avatar.png" />
        {name}
        <SVGIcon className="pull-right" name="next" />
      </DropdownItem>
      <DropdownItem href="/likes/schools" className="p-y-md">
        <SVGIcon className="icon-nav icon-align-middle m-r-md" name="campus-love" />
        {intl.get('favorite')}
        <SVGIcon className="pull-right" name="next" />
      </DropdownItem>
      <DropdownItem href="/recommended-campus" className="p-y-md">
        <SVGIcon className="icon-nav icon-align-middle m-r-md" name="star" />
        Kampus Rekomendasi
        <SVGIcon className="pull-right" name="next" />
      </DropdownItem>
      <DropdownItem href="/aptitude_test/history" className="p-y-md">
        <SVGIcon className="icon-nav icon-align-middle m-r-md" name="campus-assessment-history" />
        {intl.get('aptitude.result.history.nav_link')}
        <SVGIcon className="pull-right" name="next" />
      </DropdownItem>
      <DropdownItem href="https://learn.quipper.com/id/dashboard?utm_source=QCampus&utm_medium=referral&utm_campaign=QCtoQLearn&utm_term=jul19&utm_content=qc_profile" className="p-y-md">
        <SVGIcon className="icon-nav icon-align-middle m-r-md" name="nav-learn" />
        Belajar
        <SVGIcon className="pull-right" name="next" />
      </DropdownItem>
      <DropdownItem href="/logout" className="p-y-md">
        <SVGIcon className="icon-nav icon-align-middle m-r-md" name="nav-logout" />
        {intl.get('logout')}
        <SVGIcon className="pull-right" name="next" />
      </DropdownItem>
    </DropdownMenu>
  </NavItem>
)

DesktopMenuDropdown.propTypes = {
  name: string,
  dropdownOnClick: func,
}

export default DesktopMenuDropdown
